import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { faCheck, faTimes, faUserEdit } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS } from 'src/app/_common/constants';
import { FilterTypeEnum } from 'src/app/_common/enums/filter.enum';
import { AddOrEditUserDialogData, UserAddOrEditDialog } from './add-or-edit-dialog/user-add-or-edit.dialog';
import { RoleEnum } from './user-role.enum';
import { UserListResponse, UserModel } from './user.model';
import { UserService } from './user.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

export class UserComponent implements OnInit, OnDestroy {

  faUserEdit = faUserEdit;
  faCheck = faCheck;
  faTimes = faTimes;
  
  pageEvent: PageEvent;

  pageIndex: number = 0;
  pageSize: number = PAGE_SIZE_DEFAULT;
  pageSizeOptions: number[] = PAGE_SIZE_OPTIONS;

  sortDirection: SortDirection = '';
  sortColumn: string = '';

  items: UserModel[] = [];
  totalRows: number;

  roleEnum: typeof RoleEnum = RoleEnum;

  columns: any[] = [
    {
      name: 'lastName',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-lastName'
      }
    },
    {
      name: 'firstName',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-firstName'
      }
    },
    {
      name: 'userName',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-userName'
      }
    },
    {
      name: 'role',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-role',
        options: null
      }
    },
    {
      name: 'isActive',
      filter: {
        type: FilterTypeEnum.Select,
        name: 'filter-isActive',
        options: [
          { name: '', value: null },
          { name: 'common.yes', value: true },
          { name: 'common.no', value: false }
        ]
      }
    },
    {
      name: 'actions',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-actions',
        options: null
      }
    },
  ];

  displayedColumns: any[] = this.columns.map(x => x.name);
  filterColumns: any[] = this.columns.map(x => x.filter).map(x => x.name);
  filter: any = {};
  filterTypes: typeof FilterTypeEnum = FilterTypeEnum;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  addOrEditUserDialogData: AddOrEditUserDialogData = {
    isNewUser: false,
    userModel: { id: null, userName: null, lastName: null, firstName: null, isActive: null, roles: [], language: null }
  }

  subscription: Subscription;

  constructor(
    private userService: UserService,
    public dialog: MatDialog,
    public router: Router
  ) {
    this.subscription = this.userService.componentMethodCalled$.subscribe(() => {
      this.addOrEditUserOpenDialog(null);
    });
  }

  ngOnInit(): void {
    this.loadData();

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onPaginateChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  onSortData(event: Sort) {
    this.sortDirection = event.direction;
    this.sortColumn = event.active;
    this.pageIndex = 0;
    this.loadData();
  }

  public loadData() {
    this.userService
      .getUsers(this.pageIndex, this.pageSize, this.sortColumn, this.sortDirection, this.filter)
      .pipe(map((res: UserListResponse) => {
        this.items = res.model;
        this.totalRows = res.totalRows;
      }))
      .subscribe();
  }

  filterData(filter: any) {
    this.filter = filter;
    this.pageIndex = 0;
    this.loadData();
  }

  addOrEditUserOpenDialog(id: number) {
    if(id){
      this.addOrEditUserDialogData.isNewUser = false;
      this.addOrEditUserDialogData.userModel = this.items.filter(x => x.id == id)[0];
    }
    else {
      this.addOrEditUserDialogData.isNewUser = true;
      this.addOrEditUserDialogData.userModel = { id: null, userName: null, lastName: null, firstName: null, isActive: null, roles: [], language: null }
    }

    let dialogRef = this.dialog.open(UserAddOrEditDialog, {
      width: '400px',
      data: this.addOrEditUserDialogData,
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((data: AddOrEditUserDialogData) => {
      if(data){
        this.userService.saveUser(data.userModel).subscribe((response) => {
          if (response) {
            setTimeout(() => { this.loadData(); });
          }
        });
      }
    });
  }
}
